import React from "react";
import { Outlet, NavLink, useLocation } from "react-router-dom";

const SUB_TABS = [
  { id: "sort", path: "/evaluate/sort", label: "Sort more sheets" },
  { id: "check", path: "/evaluate/check", label: "Check more sheets" },
  { id: "recheck", path: "/evaluate/recheck", label: "Recheck" },
];

function getActiveSubTab(pathname) {
  if (pathname.includes("/pipeline")) return "";
  if (pathname.includes("/recheck")) return "recheck";
  if (pathname.includes("/check")) return "check";
  return "sort";
}

export default function EvaluateLayout() {
  const location = useLocation();
  const activeSubTab = getActiveSubTab(location.pathname);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: 0,
      position: "absolute",
      top: "var(--header-height)",
      left: 0,
      right: 0,
      bottom: 0,
      height: "calc(100vh - var(--header-height))"
    }}>
      {/* Sub-tab Menu — data-evaluate-subnav used by floating image panels
          so they clamp drag Y below this strip (and the app header). */}
      <div data-evaluate-subnav className="subnav evaluate-subnav">
        <div className="evaluate-subnav-main">
          {SUB_TABS.map((tab) => (
            <NavLink
              key={tab.id}
              to={tab.path}
              className={`subnav-tab ${activeSubTab === tab.id ? "active" : ""}`}
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>

      {/* Content Area */}
      <div style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        <Outlet />
      </div>
    </div>
  );
}
